import React from "react";
import {
  Grid,
  Typography,
  FormControlLabel,
  TextField,
  Radio,
  RadioGroup,
  Divider,
  FormHelperText,
} from "@mui/material";
const DirectoriesSettings = ({ formik, setTouched }) => {
  const handleChange = (e) => {
    setTouched(true);
    formik.handleChange(e);
  };
  return (
    <Grid
      container
      justifyContent="center"
      sx={{
        background: "#ffffff",
        borderRadius: "6px",
        border: "1px solid #E7E9EF",
        padding: "30px",
      }}
      direction="column"
    >
      <Grid item xs={12} sx={{ marginBottom: "30px" }}>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1.125rem",
            fontWeight: 550,
            lineHeight: "21px",
          }}
        >
          Directories Settings
        </Typography>
        <Typography
          sx={{
            color: "#8792AB",
            fontSize: ".875rem",
            lineHeight: "16px",
            marginTop: "5px",
          }}
        >
          Enter directory path or browse from files
        </Typography>
      </Grid>

      <Grid item xs={12} sx={{ marginBottom: "30px" }}>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1rem",
            fontWeight: 550,
            lineHeight: "21px",
          }}
        >
          Message Collection Method
        </Typography>
        <RadioGroup
          row
          name="messageMethod"
          value={formik.values.messageMethod}
          onChange={handleChange}
          sx={{ display: "flex", flexDirection: "row" }}
        >
          <FormControlLabel value="FTP_" control={<Radio />} label="FTP" />
          <FormControlLabel value="DIR_" control={<Radio />} label="DIR" />
          <FormControlLabel value="SFTP" control={<Radio />} label="SFTP" />
          <FormControlLabel value="FTPS" control={<Radio />} label="FTPS" />
          <FormControlLabel value="MQ__" control={<Radio />} label="MQ" />
        </RadioGroup>
        {Boolean(formik.errors.messageMethod) && (
          <FormHelperText id="messageMethod" error={true}>
            {formik.errors.messageMethod}
          </FormHelperText>
        )}
      </Grid>

      <Grid item xs={12}>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "10px",
          }}
        >
          General Settings
        </Typography>

        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
          }}
        >
          Incoming*
        </Typography>
        <TextField
          name="incoming"
          value={formik.values.incoming}
          onChange={handleChange}
          error={formik.touched.incoming && Boolean(formik.errors.incoming)}
          helperText={formik.touched.incoming && formik.errors.incoming}
          sx={{
            width: "420px",
            height: "36px",
            "& .MuiInputBase-root": { height: "36px" },
            "& .MuiOutlinedInput": { height: "36px" },
          }}
        />

        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
            marginTop: "25px",
          }}
        >
          Outgoing*
        </Typography>
        <TextField
          name="outgoing"
          value={formik.values.outgoing}
          onChange={handleChange}
          error={formik.touched.outgoing && Boolean(formik.errors.outgoing)}
          helperText={formik.touched.outgoing && formik.errors.outgoing}
          sx={{
            width: "420px",
            height: "36px",
            "& .MuiInputBase-root": { height: "36px" },
            "& .MuiOutlinedInput": { height: "36px" },
          }}
        />

        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
            marginTop: "25px",
          }}
        >
          To SWIFT*
        </Typography>
        <TextField
          name="toSwift"
          value={formik.values.toSwift}
          onChange={handleChange}
          error={formik.touched.toSwift && Boolean(formik.errors.toSwift)}
          helperText={formik.touched.toSwift && formik.errors.toSwift}
          sx={{
            width: "420px",
            height: "36px",
            "& .MuiInputBase-root": { height: "36px" },
            "& .MuiOutlinedInput": { height: "36px" },
          }}
        />

        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
            marginTop: "25px",
          }}
        >
          MSG History*
        </Typography>
        <TextField
          name="msgHistory"
          value={formik.values.msgHistory}
          onChange={handleChange}
          error={formik.touched.msgHistory && Boolean(formik.errors.msgHistory)}
          helperText={formik.touched.msgHistory && formik.errors.msgHistory}
          sx={{
            width: "420px",
            height: "36px",
            "& .MuiInputBase-root": { height: "36px" },
            "& .MuiOutlinedInput": { height: "36px" },
          }}
        />
      </Grid>

      <Grid item xs={12} sx={{ marginBottom: "30px" }}>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
            marginTop: "25px",
          }}
        >
          Standard Protocol*
        </Typography>
        <RadioGroup
          row
          name="standardProtocol"
          value={formik.values.standardProtocol}
          onChange={handleChange}
          sx={{ display: "flex", flexDirection: "row" }}
        >
          <FormControlLabel
            value="ALL"
            control={<Radio />}
            label="All Formats"
          />
          <FormControlLabel value="MT_" control={<Radio />} label="MT Format" />
          <FormControlLabel value="MX_" control={<Radio />} label="MX Format" />
        </RadioGroup>
        {Boolean(formik.errors.standardProtocol) && (
          <FormHelperText id="standardProtocol" error={true}>
            {formik.errors.standardProtocol}
          </FormHelperText>
        )}
      </Grid>

      <Divider sx={{ marginBottom: "30px" }} />

      <Grid item xs={12} sx={{ marginBottom: "30px" }}>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "10px",
          }}
        >
          GPI/UC
        </Typography>

        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
            marginTop: "25px",
          }}
        >
          Confirmation File
        </Typography>
        <TextField
          name="confirmationFile"
          value={formik.values.confirmationFile}
          onChange={handleChange}
          error={
            formik.touched.confirmationFile &&
            Boolean(formik.errors.confirmationFile)
          }
          helperText={
            formik.touched.confirmationFile && formik.errors.confirmationFile
          }
          sx={{
            width: "420px",
            height: "36px",
            marginBottom: "10px",
            "& .MuiInputBase-root": { height: "36px" },
            "& .MuiOutlinedInput": { height: "36px" },
          }}
        />

        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
            marginTop: "25px",
          }}
        >
          After AML
        </Typography>
        <TextField
          name="afterAMLFilter"
          value={formik.values.afterAMLFilter}
          onChange={handleChange}
          error={
            formik.touched.afterAMLFilter &&
            Boolean(formik.errors.afterAMLFilter)
          }
          helperText={
            formik.touched.afterAMLFilter && formik.errors.afterAMLFilter
          }
          sx={{
            width: "420px",
            height: "36px",
            marginBottom: "10px",
            "& .MuiInputBase-root": { height: "36px" },
            "& .MuiOutlinedInput": { height: "36px" },
          }}
        />

        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
            marginTop: "25px",
          }}
        >
          Log
        </Typography>
        <TextField
          name="logFile"
          value={formik.values.logFile}
          onChange={handleChange}
          error={formik.touched.logFile && Boolean(formik.errors.logFile)}
          helperText={formik.touched.logFile && formik.errors.logFile}
          sx={{
            width: "420px",
            height: "36px",
            marginBottom: "10px",
            "& .MuiInputBase-root": { height: "36px" },
            "& .MuiOutlinedInput": { height: "36px" },
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "10px",
          }}
        >
          Posting
        </Typography>

        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
            marginTop: "25px",
          }}
        >
          Posting
        </Typography>
        <TextField
          name="posting"
          value={formik.values.posting}
          onChange={handleChange}
          error={formik.touched.posting && Boolean(formik.errors.posting)}
          helperText={formik.touched.posting && formik.errors.posting}
          sx={{
            width: "420px",
            height: "36px",
            marginBottom: "10px",
            "& .MuiInputBase-root": { height: "36px" },
            "& .MuiOutlinedInput": { height: "36px" },
          }}
        />
      </Grid>
    </Grid>
  );
};

export default DirectoriesSettings;
